<template>
  <div>
    <h1>Planillas</h1>
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>

      <v-data-table :headers="headers" :items="planillas" :search="search">
        <template v-slot:[`item.fecha`]="props"> {{  props.item.fecha | dateFormat}} </template>
        <template v-slot:[`item.controls`]="props">
          <v-btn
            small
            class="btn btn-primary btn-sm"
            @click="editar(props.item.id)"
            >Editar
          </v-btn>
        </template>
      </v-data-table>
      <v-card-actions>
        <v-btn @click="$router.push('/')"> Volver </v-btn>
        <span>- -</span>
        <v-btn @click="agregar"> Agregar Planilla </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
export default {
  data() {
    return {
      planillas: [],
      search: "",
      headers: [
        { text: "Id", value: "id" },
        { text: "Evento", value: "nombreEvento" },
        { text: "Local", value: "local" },
        { text: "Fecha", value: "fecha" },
        { text: "Asignacion", value: "asignacion.nombre" },
        { text: "NroFactura", value: "numeroFactura" },
        { text: "Monto Fact.", value: "montoFactura" },
        { text: "Accion", value: "controls", sortable: false },
      ],
    };
  },
  mounted() {
    axios
      .get("/planillas/?estado=Pendiente")
      .then((res) => {
        console.log("res", res);
        this.planillas = res.data;
      })
      .catch((err) => console.log(err));
  },
  methods: {
    format_date(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
      }
    },
    editar(id) {
      this.$router.push("/planilla/" + id);
    },
    agregar() {
      this.$router.push("/planilla");
    },
  },
  filters: {
    dateFormat(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
      }
    },
  },
};
</script>